import React, {useEffect, useState} from "react"
import Modal from "react-bootstrap/Modal"
import useShifts from "hooks/useShifts"
import useAuth from "auth/useAuth"
import Rescuer from "components/Rescuer"
import "./Forward.css"


export default function Forward(params) {

    const {rescue, show, close, selected} = params
    const [selectedUsername, setSelectedUsername] = useState()
    const {username, admin} = useAuth()
    const shifts = useShifts()
    const shiftRescuers = shifts.getRescuers(rescue.rescue.area)
    const head = shifts.get(rescue.rescue.area)?.head

    // Opening from a participant's button preselects that participant
    useEffect(() => {
        if (show) setSelectedUsername(selected)
    }, [show, selected])

    const participants = rescue.rescue.rescuers ?? []
    const others = shiftRescuers.filter(rescuer => !rescue.containsRescuer(rescuer))
    const chosen = [...participants, ...others].find(rescuer => rescuer.username === selectedUsername)

    // Admins and the shift head can still edit the list after handing it over; everyone else loses that
    const losesRights = !admin && head?.username !== username

    const forward = () => {
        if (!selectedUsername) return
        rescue.forward(selectedUsername)
        close()
    }

    const option = rescuer => <label key={rescuer.username} className={rescuer.username === selectedUsername ? "selected" : ""}>
        <input type="radio" name="forward" checked={rescuer.username === selectedUsername} onChange={() => setSelectedUsername(rescuer.username)}/>
        <Rescuer rescuer={rescuer}/>
    </label>

    return <Modal show={show} onHide={close} id="forward">
        <Modal.Header closeButton>
            <Modal.Title>Promeni vođu akcije</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Izaberi spasioca koji postaje vođa akcije.</p>
            {participants.length > 0 && <>
                <div className="forward-group">Učesnici</div>
                {participants.map(option)}
            </>}
            {others.length > 0 && <>
                <div className="forward-group">Smena</div>
                {others.map(option)}
            </>}
            {participants.length === 0 && others.length === 0 && <div className="forward-empty">
                Nema kome da predaš listu. Prvo dodaj učesnika.
            </div>}
            {chosen && losesRights && <div className="forward-note">
                <b>{chosen.given_name} {chosen.family_name}</b> postaje vođa akcije i vlasnik liste. Ti ostaješ među učesnicima, ali više ne možeš da menjaš listu.
            </div>}
        </Modal.Body>
        <Modal.Footer>
            <button className="btn btn-primary" onClick={forward} disabled={!selectedUsername}>Promeni vođu akcije</button>
            <button className="btn btn-light" onClick={close}>Nazad</button>
        </Modal.Footer>
    </Modal>

}
